import { randomInt } from '../utils/helpers'

const COLORS = ['placeholder-bg-1', 'placeholder-bg-2', 'placeholder-bg-3', 'mild', 'mozam-paprika', 'lemon-and-herb', 'tangy-tomato']
const PATTERNS = ['default']
   
let _colorIdx = randomInt(0, COLORS.length-1)
let _patternIdx = randomInt(0, PATTERNS.length-1)

export default {

  computed: {
    placeholder() {
      // Seed can be defined on the component using this mixin which allows it to generate a consistent color/pattern pairing
      let colorIdx = this.seed != null ? (this.seed % COLORS.length) : _colorIdx++
      let patternIdx = this.seed != null ? (this.seed % PATTERNS.length) : _patternIdx++

      if(_colorIdx >= COLORS.length) _colorIdx = 0
      if(_patternIdx >= PATTERNS.length) _patternIdx = 0

      return `${COLORS[colorIdx]} pattern-bg pattern-bg--${PATTERNS[patternIdx]}`
    },
  },
}